import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-idades-min-max',
  templateUrl: './idades-min-max.component.html',
  styleUrls: ['./idades-min-max.component.scss']
})
export class IdadesMinMaxComponent {
  @Output() duplicar = new EventEmitter();
  @Output() remover = new EventEmitter();
  constructor() { }
}
